import { z } from 'zod';
import { VALID_ARTIFACT_CARDS } from './base/artifact-meta';

export const FixtureTypeSchema = z.enum(['wizard', 'single_field', 'bundle', 'insight', 'webhook_post', 'binary_approval']);
export type FixtureType = z.infer<typeof FixtureTypeSchema>;

const FixturePreviewSchema = z.object({
  recipient: z.object({ slackId: z.string(), label: z.string().optional() }),
  externalId: z.string(),
  artifactName: z.string(),
  summary: z.string().optional(),
  envelope: z.looseObject({
    schemaVersion: z.literal(2),
    type: z.enum(['approval', 'input', 'insight']),
    plan: z.looseObject({ mode: z.enum(['single_step', 'wizard']) }).optional(),
  }),
  fieldSuggestions: z
    .array(z.object({ fieldLabel: z.string(), proposedValue: z.unknown(), confidence: z.number().optional() }))
    .optional(),
  ingestionPayload: z.unknown().optional(),
});
export type FixturePreview = z.infer<typeof FixturePreviewSchema>;

export const FixturePreviewResponseSchema = z.object({
  valid: z.boolean(),
  errors: z.array(z.string()),
  fixtures: z.array(FixturePreviewSchema),
  summary: z.object({
    totalCount: z.number(),
    perRecipient: z.number(),
    fixtureType: FixtureTypeSchema,
    artifactCard: z.enum(VALID_ARTIFACT_CARDS),
  }),
});
export type FixturePreviewResponse = z.infer<typeof FixturePreviewResponseSchema>;

export const FixtureExecuteResponseSchema = z.object({
  success: z.boolean(),
  results: z.array(
    z.object({
      externalId: z.string(),
      slackId: z.string(),
      status: z.enum(['created', 'error']),
      error: z.string().optional(),
    }),
  ),
  summary: z.object({ created: z.number(), errors: z.number() }),
});
export type FixtureExecuteResponse = z.infer<typeof FixtureExecuteResponseSchema>;

const UrlOptionSchema = z.object({ label: z.string(), value: z.string() });
export type UrlOption = z.infer<typeof UrlOptionSchema>;

export const FixtureEnvConfigSchema = z.object({
  ingestionUrl: z.string(),
  terraTokenConfigured: z.boolean(),
  ingestionUrlOptions: z.array(UrlOptionSchema),
});
export type EnvConfig = z.infer<typeof FixtureEnvConfigSchema>;
